export enum ApproveDenyReasonVisibilityLevel {
  MGALevel = 'mga',
  ProspectLevel = 'prospect',
  AgencyLevel = 'agencyLevel',
  AllianceGroupLevel = 'allianceGroupLevel',
  All = 'all',
}
